import { List, Edit, Create } from "../Components/index.js";

export default [
    {
        path: "/vehicle-type/list",
        component: List,
        name: "vehicle-type-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/vehicle-type/:id/edit",
        component: Edit,
        name: "vehicle-type-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/vehicle-type/create",
        component: Create,
        name: "vehicle-type-create",
        meta: {
            requiresAuth: true,
        },
    },
];
